import { useEffect } from "react";
import { useAuth, startGoogleLogin } from "../../context/AuthContext";
import { BagLogo } from "../../components/Logo";

/** Dedicated admin.ponesi.rs entry. Separate presentation from both the customer and the Partner
 * login, on the same existing auth backend. PLATFORM_ADMIN is enforced server-side (and re-checked
 * by RequireRole); being a restaurant OWNER grants nothing here. No public admin registration. */
export default function AdminLogin() {
  const { user, loading } = useAuth();
  useEffect(() => { if (!loading && user?.role === "admin") window.location.replace("/admin"); }, [user, loading]);

  const denied = !loading && user && user.role !== "admin";
  return (
    <div className="min-h-dvh flex items-center justify-center p-6 bg-slate-950" data-testid="admin-login">
      <div className="w-full max-w-sm bg-slate-900 border border-slate-800 rounded-2xl p-8">
        <div className="flex justify-center opacity-90"><BagLogo size={44} /></div>
        <h1 className="font-display font-black text-2xl text-center text-white mt-5">
          Ponesi <span className="text-brand-red">Admin</span>
        </h1>
        <p className="text-sm text-slate-400 text-center mt-2">Administracija platforme.</p>
        {denied ? (
          <div className="mt-6 text-center" data-testid="admin-login-denied">
            <p className="text-sm font-semibold text-brand-red">Nemate administratorski pristup.</p>
            <p className="text-xs text-slate-500 mt-2">Prijavljeni ste, ali vaš nalog nema PLATFORM_ADMIN dozvolu.</p>
          </div>
        ) : (
          <button data-testid="admin-google-login" onClick={() => startGoogleLogin("/admin")}
            className="w-full mt-7 min-h-[52px] bg-white text-slate-900 rounded-xl font-display font-bold active:scale-[0.98] transition-transform">
            Prijavi se
          </button>
        )}
        <p className="text-[11px] text-slate-600 text-center mt-5">Pristup je ograničen na ovlašćene administratore.</p>
      </div>
    </div>
  );
}
